import { createSlice } from "@reduxjs/toolkit";

export const publicSurveysSlice = createSlice({
  name: "publicSurveys",
  initialState: {
    surveyInfo: null,
    isLoading: false,
  },
  reducers: {
    setSurveyInfo: (state, { payload }) => {
      state.surveyInfo = payload;
    },
    clearSurveyInfo: (state) => {
      state.surveyInfo = null;
    },
    setIsLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
  },
});

export const { setSurveyInfo, clearSurveyInfo, setIsLoading } = publicSurveysSlice.actions;

export default publicSurveysSlice.reducer;
